import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class FirmaService {
    public myurl = url + "informes/firmas/";


    constructor(private http:HttpClient) {
      
     }
     getFirma(id){
       
        let headers=new HttpHeaders();
        let body=JSON.stringify({"id":id});
       
        headers.append('Content-Type' , 'application/json');
        return this.http.post(this.myurl+"firma.php",body,{headers:headers}).pipe(map(res=>{
          
           return res;
         }));
       }
      /*  getAnexo(fecha,base){
        let headers=new HttpHeaders();
        let body=JSON.stringify({"fecha":fecha,"categoria":base});
       
        headers.append('Content-Type' , 'application/json');
        return this.http.post(url+"categoria/fechaAnexoAnterior.php",body,{headers:headers}).pipe(map(res=>{
          
           return res;
         }));
       } */
}
